import { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LOCALES = ['en', 'es'];

export const LocaleLayout: React.FC = () => {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (locale && SUPPORTED_LOCALES.includes(locale) && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  if (!locale || !SUPPORTED_LOCALES.includes(locale)) {
    return <Navigate to="/en" replace />;
  }

  return <Outlet />;
};
